import React from 'react';
import close from '../../assets/images/close.svg';

const Modal = ({ visible, icon, heading, body, handler }) => {
  return (
    <div
      className={`fixed z-30 inset-0 overflow-y-auto ${visible ? '' : 'hidden'}`}
      aria-labelledby='modal-title'
      role='dialog'
      aria-modal='true'
    >
      <div className='flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0'>
        <div
          className='fixed inset-0 bg-gray-900 bg-opacity-25 transition-opacity'
          aria-hidden='true'
          onClick={handler}
        ></div>

        <span className='hidden sm:inline-block sm:align-middle sm:h-screen' aria-hidden='true'>
          &#8203;
        </span>

        <div className='h-60 inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden transform duration-75 sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6'>
          <div>
            <div className='flex flex-row-reverse'>
              <img src={close} alt='closeIcon' className='cursor-pointer' onClick={handler} />
            </div>
            <div className='mx-auto mt-3 flex items-center justify-center h-12 w-12 rounded-full bg-green-100'>
              <img src={icon} alt='modal icon' className='inline h-7 w-7 text-green-600' />
            </div>
            <div className='mt-6 text-center'>
              <h3 className='text-xl leading-6 font-semibold text-gray-900' id='modal-title'>
                {heading}
              </h3>
              <div className='mt-2'>
                <p className='text-base text-gray-500 w-3/4 m-auto mb-3'>{body}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
